// extracted by mini-css-extract-plugin
export default {"NoRecords":"keysegment_NoRecords__LusyA","keySegmentContainer":"keysegment_keySegmentContainer__5d-Vd"};